import { get, post} from '@/utils/axios'
import qs from 'qs'

// 用户注册
export function register(data) {
	return post('sys/register', data).then(res => {
		return res
	})
}

// 用户登录
export function login(data) {
	return post('sys/login', data).then(res => {
		return res
	})
}

// 用户登出
export function logout() {
	return get('sys/logout').then(res => {
		return res
	})
}

// 获取相关内容
export function richtexts(data) {
	return post('api/richtext/richtexts',  qs.stringify(data)).then(res => {
		return res
	})
}

// 提交相关内容
export function richtext(data) {
	return post('api/richtext', qs.stringify(data)).then(res => {
		return res
	})
}

// 获取相关内容详情
export function richtextDetail(id) {
	return get(`api/richtext/id/${id}`).then(res => {
		return res
	})
}



// 获取树状结构相关内容
export function tree(data) {
	return post('api/richtext-tree', qs.stringify(data)).then(res => {
		return res
	})
}

// 获取下属子公司
export function sub(params) {
	return post('api/home/subsidiarys', qs.stringify(params)).then(res => {
		return res
	})
}

